<h2>Dispersiones Pendientes</h2>
<dx-data-grid [dataSource]="dispersions" keyExpr="id" [showBorders]="true"
  [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }">
  <dxo-load-panel [enabled]="true"></dxo-load-panel>
  <dxi-column dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate" alignment="center">
  </dxi-column>
  <dxi-column dataField="dateScheduled" caption="Fecha programada" cellTemplate="dateTemplate"
      alignment="center">
  </dxi-column>
  <dxi-column dataField="companyName" caption="Compañía" alignment="center">
  </dxi-column>
  <dxi-column dataField="programName" caption="Programa"></dxi-column>
  <!-- <dxi-column dataField="dispersionTypeName" caption="Tipo"></dxi-column> -->
  <dxi-column dataField="dispersionAmount" caption="Cantidad" dataType="number" format="currency"
      alignment="center">
      <dxo-format type="currency" [precision]="2"></dxo-format>
  </dxi-column>
  <dxi-column dataField="fees" caption="Comisión" dataType="number" format="currency" alignment="center">
      <dxo-format type="currency" [precision]="2"></dxo-format>
  </dxi-column>
  <dxi-column dataField="granTotal" caption="Total" dataType="number" format="currency" alignment="center">
      <dxo-format type="currency" [precision]="2"></dxo-format>
  </dxi-column>
  <dxo-summary>
      <dxi-total-item column="companyName" summaryType="count">
      </dxi-total-item>
      <dxi-total-item column="dispersionAmount" summaryType="sum" valueFormat="currency" precision="2">
      </dxi-total-item>
      <dxi-total-item column="fees" summaryType="sum" valueFormat="currency"></dxi-total-item>
      <dxi-total-item column="granTotal" summaryType="sum" valueFormat="currency"></dxi-total-item>
  </dxo-summary>
  <div *dxTemplate="let d of 'dateTemplate'">
      <div *ngIf="d.value"> {{d.value|numberToDate}}</div>
  </div>
  <div *dxTemplate="let dispDetails of 'detail'">
      <div class="flex flex-nowrap flex-space-between datagrid-detailsW">
          <div class="mr-5 ml-5">
              <h2>Detalle de dispersión</h2>
              <ul>
                  <li>Fecha de creación: {{dispDetails.data.dateCreated|numberToDate}}</li>
                  <li>Fecha programada: {{dispDetails.data.dateScheduled|numberToDate}}</li>
                  <li *ngIf="dispDetails.data.dateExecuted">Fecha de ejecución:
                      {{dispDetails.data.dateExecuted|numberToDate}}</li>
                  <li>Número de beneficiarios: {{dispDetails.data.beneficiaries.length}}</li>
                  <li>Programa: {{dispDetails.data.programName}}</li>
                  <li>Tipo de dispersión: {{dispDetails.data.dispersionTypeName}}</li>
                  <li *ngIf="dispDetails.data.recurrance.name">Recurrencia:
                      {{dispDetails.data.recurrance.name}}</li>
                  <li>ID: {{dispDetails.data.id}}</li>
              </ul>
          </div>
          <div class="mr-5 ml-5">
              <h2>Detalle de dispersión</h2>
              <ul>
                  <li>Cantidad a dispersar: {{dispDetails.data.dispersionAmount|currency}}</li>
                  <li>Comisión: {{dispDetails.data.fees | currency}}</li>
                  <li>IVA: {{dispDetails.data.tax | currency}}</li>
                  <li>Gran total: {{dispDetails.data.granTotal | currency}}</li>
              </ul>

          </div>
          <div class="mr-5 ml-5 pt-3">
              <dx-button text="Ver detalle de usuarios" icon="find" type="default"
                  (onClick)="viewDetail(dispDetails.data.id)">
              </dx-button>
              <br />
              <br />
              <br />
              <dx-button text="Cancelar y Eliminar Dispersión" icon="trash" type="default"
                  (onClick)="deleteDispersion(dispDetails.data.id)">
              </dx-button>
          </div>
      </div>
  </div>
</dx-data-grid>